import script from "./ApplicationsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./ApplicationsTable.vue?vue&type=script&setup=true&lang=ts"

import "./ApplicationsTable.vue?vue&type=style&index=0&id=60a46f6f&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60a46f6f"]])

export default __exports__